let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dmhIb")).then(() => parcelRequire('xvmlJ'));